import React, { useState } from 'react';

import CloseIcon from '@mui/icons-material/Close';

import './ExpandingCard.css';

import { Card, Button, IconButton } from '@mui/material';

/**
 * Renders a basic card with header that can expand and shrink
 * @todo refactor OverviewCard to use this component
 *
 * @param {Object} props
 */
function ExpandingCard(props) {
	const [expanded, setExpanded] = useState(false);

	function toggle() {
		setExpanded(!expanded);
	}

	return (
		<Card
			className={ `expandingcard ${props.className}` }
		>
			<div
				className="expandingcard__header"
				onClick={ toggle }
			>
				<div
					className="expandingcard__title"
				>
					<h3>
						{ props.title }
					</h3>
					<h4>
						{ props.subtitle }
					</h4>
				</div>
				<div
					className="expandingcard__toggle"
				>
					<Button
						onClick={ toggle }
						hidden={ expanded }
						color="primary"
					>
						Show details
					</Button>
					<IconButton
						onClick={ toggle }
						hidden={ !expanded }
						className="overview-card-actions-close"
						size="large">
						<CloseIcon
							color="inherit"
						/>
					</IconButton>
				</div>
			</div>
			{ expanded && props.children }
		</Card>
	);
}

export default ExpandingCard;
